const EXTENSION_MIME_MAP = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};

const inferMimeTypeFromFilename = (filename) => {
  if (!filename || typeof filename !== 'string') return 'application/octet-stream';

  const ext = filename.split('.').pop()?.toLowerCase();
  return EXTENSION_MIME_MAP[ext] || 'application/octet-stream';
};

export const mapAttachmentMetaByField = (attachmentMeta) => {
  if (!Array.isArray(attachmentMeta)) return {};

  return attachmentMeta.reduce((acc, meta) => {
    if (!meta || typeof meta !== 'object') return acc;
    if (typeof meta.attachment_field !== 'string' || meta.attachment_field.length === 0) return acc;

    acc[meta.attachment_field] = meta;
    return acc;
  }, {});
};

export const toRemoteFileValue = (meta) => {
  if (!meta || typeof meta !== 'object') return null;
  if (typeof meta.attachment_url !== 'string' || meta.attachment_url.length === 0) return null;

  const filename = meta.attachment_filename || 'Uploaded document';

  return {
    name: filename,
    size: 0,
    type: inferMimeTypeFromFilename(filename),
    url: meta.attachment_url,
    isRemote: true
  };
};

export const getRemoteFileByAttachmentField = (attachmentMetaByField, fieldName) => {
  return toRemoteFileValue(attachmentMetaByField?.[fieldName]);
};
